import { ChakraBox, ChakraText } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import { FunnelButton } from "./FunnelButton";

export const Uploader = () => {
  const translations = useTranslations();

  return (
    <ChakraBox mb={10} display={{ base: "block", md: "none" }}>
      <ChakraText fontSize="sm" textAlign="center" mt={2} color="greyscale.500">
        {translations("or_")}
      </ChakraText>
      <FunnelButton type="scanner" />
      <FunnelButton type="uploader" />
    </ChakraBox>
  );
};
